import React from 'react';
import Icon from '../../../components/AppIcon';

const CampaignStatus = () => {
  const campaigns = [
    {
      id: 1,
      title: 'The Digital Revolution Launch',
      author: 'Dr. Michael Chen',
      status: 'active',
      progress: 75,
      dueDate: 'Nov 15, 2024',
      type: 'Press Kit',
      priority: 'high'
    },
    {
      id: 2,
      title: 'Mystery of the Lost Pages',
      author: 'Emma Thompson',
      status: 'scheduled',
      progress: 100,
      dueDate: 'Nov 8, 2024',
      type: 'Email Campaign',
      priority: 'medium'
    },
    {
      id: 3,
      title: 'Cooking with Heart',
      author: 'Chef Maria Rodriguez',
      status: 'draft',
      progress: 45,
      dueDate: 'Nov 22, 2024',
      type: 'Press Release',
      priority: 'low'
    },
    {
      id: 4,
      title: 'Future of AI in Education',
      author: 'Prof. Sarah Williams',
      status: 'review',
      progress: 90,
      dueDate: 'Nov 12, 2024',
      type: 'Media Outreach',
      priority: 'high'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'bg-success text-success-foreground';
      case 'scheduled': return 'bg-primary text-primary-foreground';
      case 'draft': return 'bg-muted text-muted-foreground';
      case 'review': return 'bg-warning text-warning-foreground';
      default: return 'bg-muted text-muted-foreground';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'text-error';
      case 'medium': return 'text-warning';
      case 'low': return 'text-success';
      default: return 'text-muted-foreground';
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'Press Kit': return 'Briefcase';
      case 'Email Campaign': return 'Mail';
      case 'Press Release': return 'FileText';
      case 'Media Outreach': return 'Users';
      default: return 'File';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Campaign Status</h2>
        <button className="text-sm text-primary hover:text-primary/80 font-medium">
          View All Campaigns
        </button>
      </div>
      <div className="space-y-4">
        {campaigns?.map((campaign) => (
          <div key={campaign?.id} className="border border-border rounded-lg p-4 hover:shadow-sm transition-shadow duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-start space-x-3">
                <div className="p-2 bg-muted rounded-lg">
                  <Icon name={getTypeIcon(campaign?.type)} size={16} className="text-muted-foreground" />
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground mb-1">{campaign?.title}</h3>
                  <p className="text-xs text-muted-foreground">by {campaign?.author}</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(campaign?.status)}`}>
                  {campaign?.status?.charAt(0)?.toUpperCase() + campaign?.status?.slice(1)}
                </span>
                <Icon name="Circle" size={8} className={getPriorityColor(campaign?.priority)} />
              </div>
            </div>
            
            <div className="mb-3">
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs text-muted-foreground">Progress</span>
                <span className="text-xs font-medium text-foreground">{campaign?.progress}%</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div 
                  className="bg-primary rounded-full h-2 transition-all duration-300"
                  style={{ width: `${campaign?.progress}%` }}
                />
              </div>
            </div>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-1">
                <Icon name="Calendar" size={14} className="text-muted-foreground" />
                <span className="text-xs text-muted-foreground">Due: {campaign?.dueDate}</span>
              </div>
              <span className="text-xs text-muted-foreground">{campaign?.type}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CampaignStatus;